<form>
  <!-- Modal Header -->
  <div class="modal-header">
    <h4 class="modal-title">Update Profile</h4>
    <button type="button" class="btn-close" data-dismiss="modal" tabindex="-1" (click)="reset()" aria-label="Close"></button>
  </div>

  <div class="modal-body">
    <div class="container-fluid p-0">
      <div class="p-4">
        <div class="row mb-2">
          <div class="col col-12">
            <div>Customer Code</div>
            <div><input type="text" [(ngModel)]="profileNew.CustomerCode" name="customerCode" class="form-control" required /></div>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col">
            <div>Company Name</div>
            <div><input type="text" class="form-control" required [(ngModel)]="profileNew.Occupation" name="custOccupation" /></div>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col col-12 col-md-6">
            <div>Salary</div>
            <div><input type="number" class="form-control" required [(ngModel)]="profileNew.Salary" name="salaryAmount" /></div>
          </div>
          <div class="col col-12 col-md-6">
            <div>Salary Day</div>
            <div><input type="number" class="form-control" required [(ngModel)]="profileNew.SalaryDay" name="salaryDay" /></div>
            <span class="text-danger">Between (1-31). If more than 1, fill another at Description</span>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col">
            <div>Description</div>
            <div><textarea class="form-control" cols="30" required [(ngModel)]="profileNew.Remark" name="remark"></textarea></div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button class="btn btn-outline-success" type="button" (click)="submit()" [disabled]="disableSubmit">Update Profile</button>
    <button class="btn btn-outline-danger" type="button" data-dismiss="modal" (click)="reset()">Cancel</button>
  </div>
</form>
